import request from './request';

/**
 * Rider <-> admin support chat.
 *
 * Backed by the `chats` MySQL table through:
 *   GET  /api/v1/dashboard/admin/support/chats
 *   GET  /api/v1/dashboard/admin/support/chats/{riderId}/messages
 *   POST /api/v1/dashboard/admin/support/chats/{riderId}/messages
 *
 * `request` already adds the Bearer token and returns `response.data`.
 */
const supportChatService = {
  getThreads: (params) =>
    request.get('dashboard/admin/support/chats', { params }),
  getMessages: (riderId) =>
    request.get(`dashboard/admin/support/chats/${riderId}/messages`),
  reply: (riderId, data) =>
    request.post(`dashboard/admin/support/chats/${riderId}/messages`, data),
};

export default supportChatService;
